"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductStatusWrapper = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TEXT_COLORS = function TEXT_COLORS(theme) {
  return {
    published: "rgb(34, 154, 22)",
    waiting: "rgb(183, 33, 54)",
    refused: theme.palette.error.contrastText,
    draft: theme.palette.grey[800],
    other: theme.palette.common.black
  };
};
var BG_COLORS = function BG_COLORS(theme) {
  return {
    published: "rgba(84, 214, 44, 0.16)",
    waiting: "rgba(255, 72, 66, 0.16)",
    refused: theme.palette.error.main,
    draft: theme.palette.grey[200],
    other: theme.palette.common.white
  };
};
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    status: {
      minWidth: "22px",
      borderRadius: "6px",
      cursor: "default",
      whiteSpace: "nowrap",
      padding: "6px 8px",
      backgroundColor: function backgroundColor(_ref) {
        var status = _ref.status;
        return _lodash.default.get(theme.palette.custom.tableProductStatus, status, {
          bgColor: BG_COLORS(theme)[status] || BG_COLORS(theme).other
        }).bgColor;
      },
      color: function color(_ref2) {
        var status = _ref2.status;
        return _lodash.default.get(theme.palette.custom.tableProductStatus, status, {
          textColor: TEXT_COLORS(theme)[status] || TEXT_COLORS(theme).other
        }).textColor;
      }
    }
  };
});
var ProductStatusWrapper = function ProductStatusWrapper(_ref3) {
  var status = _ref3.status,
    children = _ref3.children;
  var classes = useStyles({
    status: status
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.status
  }, children);
};
exports.ProductStatusWrapper = ProductStatusWrapper;